import { render } from "./AddAbonnementPage.vue?vue&type=template&id=a61ac622&ts=true"
import script from "./AddAbonnementPage.vue?vue&type=script&lang=ts"
export * from "./AddAbonnementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__